import { Slider } from "../modules/slider";
import { TextPopup } from "../modules/textPopup";

const sections = document.querySelectorAll("section.authors");

if (sections.length > 0) {

    const handlePopup = (card, popup) => {
        const title = card.querySelector('.authors__item-name');
        const position = card.querySelector('.authors__item-position');
        const image = card.querySelector('.authors__item-popup-image');
        const bio = card.querySelector('.authors__item-bio');
        popup = new TextPopup({
            card: card,
            name: title.textContent || null,
            position: position.textContent || null,
            bio: bio.innerHTML || null,
            image:
                {
                    alt: image.alt,
                    title: image.title,
                    src: image.src,
                } || null,
        });
    };

    sections.forEach(element => {
        const cards = element.querySelectorAll(".authors__item");
        if (cards.length > 0) {
            cards.forEach(card => {
                const bioButton = card.querySelector(".authors__item-bio-button");
                if (!bioButton) return;

                let popup = null;

                bioButton.addEventListener("click", (e) => {
                    handlePopup(card, popup);
                })
            });
        }

    });
}